import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, ArrowUp, ArrowDown, Save, Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

export function OpeningEditor() {
  const [qs, setQs] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { http.get("/opening/questions").then((r) => setQs(r.data)); }, []);
  if (!qs) return null;
  const upd = (i, patch) => setQs(qs.map((q, j) => (j === i ? { ...q, ...patch } : q)));
  const move = (i, d) => { const n = [...qs]; [n[i], n[i + d]] = [n[i + d], n[i]]; setQs(n); };
  const save = async () => {
    if (qs.some((q) => q.text.trim().length < 2)) { toast.error("Boş soru bırakmayın"); return; }
    setSaving(true);
    try { const { data } = await http.put("/opening/questions", { questions: qs }); setQs(data); toast.success("Açılış listesi kaydedildi"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Kaydedilemedi"); }
    finally { setSaving(false); }
  };
  return (
    <div className="space-y-4 max-w-3xl" data-testid="opening-editor">
      <p className="text-sm text-slate-400">Sorular her sabah 08:20'de tüm şubelere atanır. Şubeden bir kişi doldurunca diğerlerine sorulmaz.
        <Bell size={12} className="inline mx-1 text-amber-300" />işaretli sorulara "Hayır" denirse şube müdürüne ve size bildirim gider.</p>
      <div className="space-y-2">
        {qs.map((q, i) => (
          <div key={q.id || i} className="flex items-center gap-2 rounded-2xl border border-slate-800 bg-slate-900/60 p-2.5" data-testid={`opening-q-${i}`}>
            <span className="w-6 text-center font-mono text-xs text-slate-500">{i + 1}</span>
            <Input value={q.text} onChange={(e) => upd(i, { text: e.target.value })} placeholder="Örn: PC'ler açık mı?" className="bg-slate-950/50 border-slate-700" data-testid={`opening-q-text-${i}`} />
            <label className="flex items-center gap-1.5 text-[11px] text-slate-400 whitespace-nowrap" title="Hayır denirse bildir">
              <Switch checked={q.notify} onCheckedChange={(v) => upd(i, { notify: v })} data-testid={`opening-q-notify-${i}`} />
              <Bell size={13} className={q.notify ? "text-amber-300" : ""} />
            </label>
            <button disabled={i === 0} onClick={() => move(i, -1)} className="p-1.5 rounded-lg hover:bg-slate-800 disabled:opacity-30" data-testid={`opening-q-up-${i}`}><ArrowUp size={14} /></button>
            <button disabled={i === qs.length - 1} onClick={() => move(i, 1)} className="p-1.5 rounded-lg hover:bg-slate-800 disabled:opacity-30" data-testid={`opening-q-down-${i}`}><ArrowDown size={14} /></button>
            <button onClick={() => setQs(qs.filter((_, j) => j !== i))} className="p-1.5 rounded-lg hover:bg-slate-800 text-red-400" data-testid={`opening-q-delete-${i}`}><Trash2 size={14} /></button>
          </div>
        ))}
        {!qs.length && <div className="text-sm text-slate-500 py-4" data-testid="opening-editor-empty">Henüz soru yok. Soru ekleyin.</div>}
      </div>
      <div className="flex justify-between gap-2">
        <Button variant="outline" className="border-slate-700" onClick={() => setQs([...qs, { text: "", notify: false }])} data-testid="opening-q-add"><Plus size={14} className="mr-1" /> Soru Ekle</Button>
        <Button onClick={save} disabled={saving} className="bg-blue-600 hover:bg-blue-500" data-testid="opening-q-save"><Save size={14} className="mr-1" /> Kaydet</Button>
      </div>
    </div>
  );
}
